import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CustomTittle from '../../components/Elements/customTittle/customTittle';
import CustomRedText from '../../components/Elements/redText/redText';

import Icon from '@mdi/react';
import { mdiPhone, mdiEmailNewsletter } from '@mdi/js';
import './customerService.css';
const CustomerService = (props) => {
    useEffect(() => {
        props.setHeader('/  OBSŁUGA KLIENTA');
    }, []);

    function copy(e) {

        var inp = document.createElement('input');
        document.body.appendChild(inp);
        inp.value = e.target.textContent;
        inp.select();
        document.execCommand('copy', false);
        inp.remove();
    }
    return (
        <>
            <div className="dashboard__content">
                <main>
                    <div className="serviceWrapperCustomer">
                        <div className="serviceContent">
                            <CustomTittle size={'h4'}>OBSŁUGA KLIENTA/INFOLINIA</CustomTittle>
                            <div className="serviceContent_open">
                                <CustomTittle size={'small'}>
                                    czynna od poniedziałku do piątku
                                </CustomTittle>
                                <CustomTittle size={'small'}>w godzinach 9:00-17:00</CustomTittle>
                            </div>
                            <div
                                className="serviceContent_phonNumber"
                                title="Kliknij na numer żeby skopiować"
                            >
                                <CustomTittle size={'small'}>Telefon komórkowy</CustomTittle>
                                <CustomRedText
                                    clickFunction={(e) => {
                                        copy(e);
                                    }}
                                >
                                    <Icon
                                        path={mdiPhone}
                                        color="black"
                                        size={1}
                                        style={{ marginRight: '10px' }}
                                    />
                                    601 20 20 20
                                </CustomRedText>
                            </div>
                            <div
                                className="serviceContent_phonNumber"
                                title="Kliknij na emial żeby skopiować"
                            >
                                <CustomTittle size={'small'}>Email:</CustomTittle>
                                <CustomRedText
                                    clickFunction={(e) => {
                                        copy(e);
                                    }}
                                >
                                    <Icon
                                        path={mdiEmailNewsletter}
                                        size={1}
                                        color="black"
                                        style={{ marginRight: '10px' }}
                                    />
                                    studio@egurrola.pl
                                </CustomRedText>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default CustomerService;
